
import './index.less'

import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import util from '@/javascript/util'

import Cpts013 from '@/components/lyx-components/lyx-footer/index.vue'
import Cpts019 from '@/components/jts-components/cpts019/index.vue'
import loading from '@/components/public-components/loading/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Cpts022 from '@/components/jts-components/cpts022/index.vue'

export default {
directives: {
TransferDom
},
components: {
Previewer,
Cpts013,
Cpts019,
loading,
Cpts022,
goBack
},
data () {
return {
attractionsEntity: {},
bannerImgUrl: '',
gallery: [],
minHeight: 0,
hasAudio: false,
audioData: {},
audioUrl: ''
/*audio: {
audioUrl: '',
playState: false,
showState: false
}*/
}
},
created () {

},
mounted () {
this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight

this.$http.get('/api/wtcp-bics/public/poi/getOne/' + this.$route.params.id).then((response) => {
const attrData = response.data.data
let gallery = []

if (attrData.fileList.image.all.materials.length > 0) {
attrData.fileList.image.all.materials.forEach(item => {
gallery.push({ src: this.PIC_BASE_URL + item.fileUrl })
})
}
/*if (attrData.fileList.audio) {
this.$set(this.audio, 'audioUrl', attrData.fileList.audio.default[0].fileUrl)
}*/
/*if (attrData.fileList.audio) {
this.hasAudio = typeof attrData.fileList.audio.default[0].fileUrl === 'string'
attrData.attractionsEntity.audioUrl = attrData.fileList.audio.default[0].fileUrl
}*/
this.$set(this, 'attractionsEntity', attrData.poiEntity)
this.$set(this, 'bannerImgUrl', gallery[0].src)
if (gallery.length > 0) {
this.$set(this, 'gallery', gallery)
this.$set(this, 'bannerImgUrl', gallery[0].src)
}

document.title = attrData.poiEntity.title

})
},
methods: {
changeShutter: function (arg) {
this[arg] = !this[arg]
},
showViewer () {
this.$refs.previewer.show(0)
},
audioPlay: function (data) {
if (typeof data.audioUrl === 'string' && data.audioUrl != this.audioUrl) {
const audioData = {
name: data.name,
url: data.audioUrl,
playState: true,
showState: true
}
this.audioUrl = data.audioUrl
this.$set(this, 'audioData', audioData)
}
}
/*thisplayHandle () {
this.audio.playState = !this.audio.playState
if (this.audio.playState) {
this.audio.showState = true
this.audioPlay()
} else {
this.audioPause()
}
},
showHandle () {
this.audio.showState = !this.audio.showState
if (!this.audio.showState) {
this.audio.playState = false
this.audioLoad()
}
},
audioPlay () {
this.$refs.audio.play()
},
audioPause () {
this.$refs.audio.pause()
},
audioStop () {
this.audio.playState = false
this.audio.showState = false
},
audioLoad () {
this.$refs.audio.load()
}*/
}
}
